module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAACCAYAAADl56r+AAAAHklEQVQokWP878f8n2GQAGf3PwPtBDhgGmgHDFYAAJHsA9mBoJnOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-affirming.png
// module id = 1013
// module chunks = 2